import { createReduxEssentials } from '@helpers/createReduxEssentials'

import { GLOBAL_STATE, actionNames } from '../constants/actionTypes'

const { reducer, actionTypes, actions, selectors } = createReduxEssentials(actionNames, GLOBAL_STATE)

export const FEEDBACK = GLOBAL_STATE

export { reducer, actionTypes, actions, selectors }
